import { LegalEntityType } from  'further-types/legal-entity'

export const LegalEntityLabels: Record<LegalEntityType, string> = {
  [LegalEntityType.Charity]: 'Charity', 
  [LegalEntityType.C_Corporation]: 'C-corporation (US)',
  [LegalEntityType.ExtraGovernmentalBody]: 'Extra-governmental body',
  [LegalEntityType.LimitedLiabilityCompany]: 'Limited liability company',
  [LegalEntityType.LimitedLiabilityPartnership]: 'Limited liability partnership',
  [LegalEntityType.LimitedPartnership]: 'Limited partnership',
  [LegalEntityType.GeneralPartnership]: 'Other (general) partnership',
  [LegalEntityType.PensionFund]: 'Pension fund',
  [LegalEntityType.S_Corporation]: 'S-corporation (US)',
  [LegalEntityType.StateOwnedEnterprise]: 'State-owned enterprise or government body',
  [LegalEntityType.Trust]: 'Trust',
  [LegalEntityType.Other]: 'Other',
}

export const legalEntityTypeDropdownOptions = (Object.values(LegalEntityType)).map(value => ({ value, label: LegalEntityLabels[value] }))
